/**
 * Size picker — 3-Schritt-Größenwahl mit Lieferstufen (aplug.pl, 2026-09-10).
 *
 * Schritt 1  Produktseite zeigt die vorgewählte Größe + Button „Größe wählen“.
 * Schritt 2  Drawer mit Größen-Grid, jede Kachel mit Preis.
 * Schritt 3  Unter dem Grid je eine Radio-Karte pro Lieferstufe der Größe.
 *
 * WARUM JS UND NICHT LIQUID: welche Stufen angeboten werden, hängt von den
 * Preisen der Geschwister-Varianten DER GEKLICKTEN Größe ab. Liquid kann nicht
 * auf eine Auswahl hin neu rendern, und die Daten liegen ohnehin schon als
 * [data-product-json] im DOM — ein Normalizer ersetzt damit die fünf
 * duplizierten „verstecke Plain wenn 72H-Zwilling da ist“-Kopien in
 * snippets/product-blocks.liquid, ohne einen einzigen Netzwerk-Request.
 *
 * DATENMODELL: heute liefert das Dashboard EINE Variante pro Größe, deren
 * Suffix (48H✔️ / 72H / keins) den Lieferstatus trägt und per Preiskonkurrenz
 * umbenannt wird. Später sollen 2–3 Varianten pro Größe gleichzeitig stehen.
 * Dieser Code nimmt NIE an, dass es nur eine Stufe gibt: Stufen sind die
 * Mitglieder einer sizeKey-Gruppe, gerendert werden offeredTiers.length Karten.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self,
    (global.themegoal = global.themegoal || {},
     global.themegoal.components_business = global.themegoal.components_business || {},
     global.themegoal.components_business.size_picker = factory()));
})(this, (function () {
  'use strict';

  /** Schnell zuerst. Bestimmt die Reihenfolge der Lieferkarten und wer bei
   *  „nur eine Stufe zeigen“ als schnellste gilt. */
  var TIER_RANK = { '48h': 0, '72h': 1, 'preorder': 2 };
  var TIER_ORDER = ['48h', '72h', 'preorder'];

  /* Deko-Zeichen: ✅ ✔ ☑ und der Variation Selector-16. Sie tragen keine
   * Information — dieselbe Größe kommt als „42 - 48H✔️“ und „42 - 48H“ vor. */
  var EMOJI_RE = /[✅✔☑️⃣]+/gu;
  /* Trailing „- 48H“ / „-72 H“ / „ 48h“, Bindestrich beliebigen Typs, optional. */
  var TIER_RE = /^(.*?)\s*(?:[-–—]\s*)?(48|72)\s*[hH]\s*$/u;
  /* Größenzahl: ganze Zahl, optional mit Drittelbruch ("36 2/3") ODER
   * Dezimalstelle ("44.5"). Der Bruch MUSS mit rein — aplug führt bei adidas
   * überwiegend Drittelgrößen, und ohne ihn las der Ausdruck aus
   * "36 2/3 EU" die 3 des Nenners statt der 36 (gefunden 2026-09-10 an der
   * Live-Produktseite: 9 von 16 Größen betroffen, Kachelbeschriftung und
   * Sortierung waren dadurch beide falsch). */
  var SIZE_NUM = '\\d{1,2}(?:\\s+\\d\\/\\d)?(?:[.,]\\d)?';
  /* Crocs & Co. tragen SPANNEN statt einer Zahl: „39-40 EU - 7 US“. Der
   * Bindestrich darin gehoert zur Groesse, nicht zwischen EU- und US-Teil —
   * ohne die Spanne im Ausdruck griff die Zahl direkt vor „EU“ und die Kachel
   * behauptete „40 EU“, wo „39-40 EU“ steht (Alex, via Karim 2026-09-17). */
  var EU_SPAN = '(?:' + SIZE_NUM + '\\s*[-\u2013\u2014]\\s*)?' + SIZE_NUM;
  var EU_RE = new RegExp('(' + EU_SPAN + ')\\s*EU\\b', 'i');
  /* US-Größen tragen bei Kinder-/GS-Schuhen einen Skalenbuchstaben hinter der
   * Zahl — adidas „38 EU - 5.5Y US“, „36 EU - 4Y US“, Nike „28.5 EU - 11.5C
   * US“. Ohne ihn fand der Ausdruck nichts und der US-Schalter zeigte die
   * Rohbezeichnung (Karim 2026-09-14). Der Buchstabe bleibt im Label. */
  var US_RE = new RegExp('(' + SIZE_NUM + '\\s*[A-Za-z]?)\\s*US\\b', 'i');
  /* Führende Zahl für die Sortierung, wenn kein „EU“ dransteht. */
  var LEADING_NUM_RE = new RegExp('^(' + SIZE_NUM + ')');

  /**
   * Größenangabe als Zahl, für die Sortierung. "36 2/3" -> 36.667,
   * "44.5" -> 44.5, "36" -> 36. Ohne das landeten alle Drittelgrößen auf
   * demselben Sortierwert.
   */
  function sizeToNumber(raw) {
    if (raw == null) return null;
    var m = /^(\d{1,2})(?:\s+(\d)\/(\d))?(?:[.,](\d))?$/.exec(String(raw).trim());
    if (!m) {
      var f = parseFloat(String(raw).replace(',', '.'));
      return isNaN(f) ? null : f;
    }
    var v = parseInt(m[1], 10);
    if (m[2] && m[3] && parseInt(m[3], 10) !== 0) {
      v += parseInt(m[2], 10) / parseInt(m[3], 10);
    } else if (m[4]) {
      v += parseFloat('0.' + m[4]);
    }
    return v;
  }

  /**
   * Einen Optionswert in Größe + Lieferstufe zerlegen.
   * „42 EU - 8.5 US - 48H✔️“ -> { sizeKey: '42 EU - 8.5 US', tier: '48h' }
   * „M“                      -> { sizeKey: 'M',              tier: 'preorder' }
   */
  function parseSizeValue(raw) {
    var s = String(raw == null ? '' : raw).replace(EMOJI_RE, '').replace(/\s+/g, ' ').trim();
    var tier = 'preorder';
    var m = TIER_RE.exec(s);
    if (m) {
      s = m[1].replace(/[\s\-–—]+$/u, '').trim();
      tier = m[2] === '48' ? '48h' : '72h';
    }
    // Bindestriche vereinheitlichen, damit „42 EU-8.5 US“ und „42 EU - 8.5 US“
    // in dieselbe Gruppe fallen. Ein Bindestrich ZWISCHEN ZWEI ZIFFERN ist
    // dagegen Teil der Groesse („39-40 EU“) und bleibt eng — er wurde sonst zu
    // „39 - 40 EU“ auseinandergezogen, und danach las jeder Ausdruck die 40.
    var sizeKey = s
      .replace(/(\d)\s*[-–—]\s*(\d)/g, '$1\u0000$2')
      .replace(/\s*[-–—]\s*/g, ' - ')
      .replace(/\u0000/g, '-');
    var eu = EU_RE.exec(sizeKey);
    var us = US_RE.exec(sizeKey);
    return {
      sizeKey: sizeKey,
      tier: tier,
      sizeLabel: {
        raw: sizeKey,
        // Bruchgrößen behalten ihre Schreibweise ("36 2/3"); nur das
        // Dezimalkomma wird vereinheitlicht.
        eu: eu ? eu[1].replace(/(\d),(\d)/, '$1.$2') : null,
        us: us ? us[1].trim().replace(/(\d),(\d)/, '$1.$2').replace(/\s*([A-Za-z])$/, '$1').toUpperCase() : null
      }
    };
  }

  function optionValueOf(variant, position) {
    return variant['option' + position];
  }

  /** Position der Größen-Option: bevorzugt die von Liquid gemeldete, sonst die
   *  erste Option, deren Wert wie eine EU-Größe aussieht. */
  function detectSizeOptionPosition(productData, hinted) {
    if (hinted && hinted >= 1 && hinted <= 3) return hinted;
    var variants = productData && productData.variants;
    if (!variants || !variants.length) return 1;
    for (var pos = 1; pos <= 3; pos++) {
      for (var i = 0; i < variants.length; i++) {
        var v = optionValueOf(variants[i], pos);
        if (v && EU_RE.test(String(v))) return pos;
      }
    }
    return 1;
  }

  /**
   * Alle Varianten in das normalisierte Modell überführen.
   * settings.plainWithStockTier: eine suffixlose Variante mit geführtem
   * Bestand gilt als diese Stufe (spiegelt die bisherige Lagerinfo-Logik und
   * das Fast-Delivery-Icon der Collection-Karten).
   */
  function normalizeVariants(json, settings) {
    var productData = (json && json.product) || {};
    var inventories = (json && json.inventories) || {};
    var pos = detectSizeOptionPosition(
      productData,
      json && json.size_picker && json.size_picker.option_position
    );
    var plainWithStockTier = (settings && settings.plainWithStockTier) || 'preorder';
    var list = [];
    var byVariantId = {};
    var variants = productData.variants || [];

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var optionValue = optionValueOf(variant, pos);
      var parsed = parseSizeValue(optionValue);
      var inv = inventories[String(variant.id)] || {
        inventory_management: variant.inventory_management,
        inventory_policy: variant.inventory_policy,
        inventory_quantity: variant.inventory_quantity
      };
      var tier = parsed.tier;
      if (tier === 'preorder' && plainWithStockTier !== 'preorder' &&
          inv && inv.inventory_management === 'shopify' && Number(inv.inventory_quantity) > 0) {
        tier = plainWithStockTier;
      }
      var others = [];
      for (var p = 1; p <= 3; p++) if (p !== pos) others.push(optionValueOf(variant, p) || null);

      var fp = (json && json.formatted_prices) ? json.formatted_prices[String(variant.id)] : null;
      var entry = {
        formattedPrice: fp ? fp.price : null,
        formattedCompareAtPrice: fp ? fp.compare_at_price : null,
        variantId: variant.id,
        sizeKey: parsed.sizeKey,
        sizeLabel: parsed.sizeLabel,
        tier: tier,
        rawTier: parsed.tier,
        price: variant.price,
        compareAtPrice: variant.compare_at_price || null,
        available: Boolean(variant.available),
        inventory: inv,
        optionPosition: pos,
        optionValue: optionValue,
        otherOptions: others,
        variant: variant
      };
      list.push(entry);
      byVariantId[String(variant.id)] = entry;
    }
    return { list: list, byVariantId: byVariantId, optionPosition: pos };
  }

  function sameOthers(a, b) {
    if (!b) return true;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  /** Nach Größe gruppieren. otherOptionsSelection filtert bei mehroptionalen
   *  Produkten auf die aktuell gewählte Farbe o.ä. */
  function groupBySize(list, otherOptionsSelection) {
    var map = {};
    var order = [];
    for (var i = 0; i < list.length; i++) {
      var e = list[i];
      if (!sameOthers(e.otherOptions, otherOptionsSelection)) continue;
      if (!map[e.sizeKey]) {
        var num = null;
        if (e.sizeLabel.eu) num = sizeToNumber(e.sizeLabel.eu);
        else {
          var lead = LEADING_NUM_RE.exec(e.sizeKey);
          if (lead) num = sizeToNumber(lead[1]);
        }
        map[e.sizeKey] = {
          sizeKey: e.sizeKey,
          sizeLabel: e.sizeLabel,
          order: num === null ? 1000 + order.length : num,
          tiers: [],
          offeredTiers: [],
          available: false,
          minOfferedPrice: null,
          hasMultipleOffered: false
        };
        order.push(map[e.sizeKey]);
      }
      map[e.sizeKey].tiers.push(e);
    }
    order.forEach(function (g) {
      g.tiers.sort(function (a, b) { return TIER_RANK[a.tier] - TIER_RANK[b.tier]; });
    });
    order.sort(function (a, b) { return a.order - b.order; });
    return order;
  }

  /**
   * Welche Stufen einer Größe der Kunde zu sehen bekommt.
   *
   * Regeln (Karim 2026-09-12, Umstellung auf getrennte Varianten je Stufe):
   *   - 48H und 72H vorhanden: 72H NUR, wenn es echt günstiger ist als 48H
   *     (Karim 2026-09-18). 72H ist die langsamere Stufe; ist sie gleich teuer
   *     oder teurer, hat sie für den Kunden keinen Vorteil und fällt weg. Die
   *     Größe fällt damit auf die 48H-Regel unten zurück — Pre-Order kann dann
   *     neben 48H erscheinen, wenn sie den Abstand einhält.
   *   - 48H und Pre-Order bzw. 72H und Pre-Order: die schnellere Stufe;
   *     Pre-Order NUR, wenn sie günstiger ist als diese — und zwar um
   *     mindestens thresholdPercent ihres Preises. Ist die schnellere Stufe
   *     günstiger oder gleich teuer, erscheint Pre-Order nie (Karim
   *     2026-09-13, dieselbe Regel für 48H und 72H). thresholdPercent = 0
   *     oder der Produkt-Tag SHOW-PREORDER (settings.showPreorder,
   *     Dashboard-Schalter) lockern nur den Mindestabstand: jede günstigere
   *     Pre-Order wird dann angeboten.
   *   - nur eine Stufe: diese.
   * settings.showAll (Demo) zeigt alle Stufen.
   */
  function resolveOfferedTiers(group, settings) {
    var cfg = settings || {};
    // Eine Stufe ohne Preis (0 zł) wird nie angeboten — eine Kachel zeigt
    // dann "wyprzedane" statt "0 zł" (AF1 Low '07 White, 38: Karim 2026-09-14).
    var candidates = group.tiers.filter(function (t) { return t.available && t.price > 0; });
    var byTier = {};
    for (var i = 0; i < candidates.length; i++) byTier[candidates[i].tier] = candidates[i];
    // 72H ohne Preisvorteil ist nur eine langsamere Lieferung desselben Paares:
    // raus, bevor die Stufen gewählt werden (Karim 2026-09-18). Gleicher Preis
    // zählt nicht als Vorteil. Der Demo-Modus (showAll) zeigt weiter alles.
    if (!cfg.showAll && byTier['48h'] && byTier['72h'] &&
        byTier['72h'].price >= byTier['48h'].price) {
      candidates = candidates.filter(function (t) { return t.tier !== '72h'; });
      delete byTier['72h'];
    }
    var offered;

    if (candidates.length <= 1 || cfg.showAll) {
      offered = candidates;
    } else if (byTier['48h'] && byTier['72h']) {
      offered = [byTier['48h'], byTier['72h']];
    } else if ((byTier['48h'] || byTier['72h']) && byTier.preorder) {
      var faster = byTier['48h'] || byTier['72h'];
      var pfast = faster.price;
      var ppre = byTier.preorder.price;
      var threshold = Number(cfg.thresholdPercent) || 0;
      var cheaper = pfast > 0 && ppre < pfast;
      var margin = (threshold <= 0 || cfg.showPreorder === true)
        ? true
        : ppre <= pfast * (1 - threshold / 100);
      offered = (cheaper && margin) ? [faster, byTier.preorder] : [faster];
    } else {
      offered = candidates;
    }

    group.offeredTiers = offered;
    group.available = offered.length > 0;
    group.hasMultipleOffered = offered.length > 1;
    group.minOfferedPrice = offered.length
      ? offered.reduce(function (min, t) { return t.price < min ? t.price : min; }, offered[0].price)
      : (group.tiers.length ? group.tiers[0].price : null);

    // Anzeigetext der guenstigsten angebotenen Stufe — damit die Kachel
    // denselben vorformatierten Preis zeigt wie die zugehoerige Lieferkarte.
    group.minOfferedFormatted = null;
    for (var mi = 0; mi < offered.length; mi++) {
      if (offered[mi].price === group.minOfferedPrice) {
        group.minOfferedFormatted = offered[mi].formattedPrice;
        break;
      }
    }

    return group;
  }

  /**
   * Preis als Text. Bevorzugt den in Liquid vorformatierten String (kommt im
   * Produkt-JSON mit und trifft das Shop-Format exakt); nur wenn der fehlt,
   * wird clientseitig formatiert.
   */
  function money(cents, format, formatted) {
    if (formatted) return formatted;
    try {
      return themegoal.helpers.Currency.formatMoney(cents, format);
    } catch (e) {
      return String(Math.round(cents / 100));
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Demo-Modus ───────────────────────────────────────────────────────
     Heute liefert das Dashboard EINE Variante pro Groesse. Um trotzdem zu
     sehen, wie drei Stufen nebeneinander wirken, erfindet der Demo-Modus die
     fehlenden Stufen aus der echten Variante. Erfundene Stufen sind sichtbar
     als Demo markiert und ausdruecklich NICHT bestellbar — ihre ID ist nicht
     numerisch, sie kann also nie mit einer echten Varianten-ID verwechselt
     werden. Einschalten per Theme-Einstellung oder ?sp_demo=1 in der URL.

     Die Abstaende sind bewusst gemischt: zwei Buckets liegen unter der
     15-%-Schwelle (dann zeigt die Regel nur die bevorzugte Stufe), zwei
     darueber (dann bekommt der Kunde die Wahl). So sieht man beide Faelle
     auf einer Produktseite. */
  var DEMO_SPREADS = [
    { s72: 0.03, s48: 0.05 },
    { s72: 0.10, s48: 0.22 },
    { s72: 0.06, s48: 0.35 },
    { s72: 0.01, s48: 0.04 }
  ];
  var DEMO_LOCATIONS = ['Lodz, Piotrkowska 141', 'Gda\u0144sk, Pa\u0144ska 9/11'];

  /** Demo-Preise auf volle 5 zl runden. Die echte Preisautomatik rundet auf
   *  0 oder 5; krumme Betraege wie 777,78 zl fallen im direkten Vergleich
   *  sofort als unecht auf und machen die Vorschau wertlos. */
  function demoRound(minorUnits) {
    return Math.max(500, Math.round(minorUnits / 500) * 500);
  }

  function demoTierFrom(base, tier, price, locations) {
    var copy = {};
    for (var k in base) if (Object.prototype.hasOwnProperty.call(base, k)) copy[k] = base[k];
    copy.variantId = 'demo-' + base.variantId + '-' + tier;
    copy.tier = tier;
    copy.rawTier = tier;
    copy.price = price;
    copy.compareAtPrice = null;
    copy.formattedPrice = null;            // money() formatiert ueber den Theme-Helper
    copy.formattedCompareAtPrice = null;
    copy.available = true;
    copy.demo = true;
    copy.locations = locations || null;
    return copy;
  }

  /** Ergaenzt jede kaufbare Groesse auf 48H + 72H + Pre-Order. Aendert group.tiers. */
  function synthesizeDemoTiers(groups) {
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var real = g.tiers.filter(function (t) { return t.available; });
      if (!real.length) continue;          // ausverkaufte Groesse bleibt ausverkauft
      var base = real[0];
      var vorhanden = {};
      for (var t = 0; t < g.tiers.length; t++) vorhanden[g.tiers[t].tier] = true;

      // Streuung ueber den Index der Groesse, nicht ueber einen Hash der
      // Varianten-ID: aplugs IDs teilen lange gemeinsame Praefixe, ein
      // einfacher Hash landete darauf nachweislich nie auf allen Restklassen
      // (22 Groessen, mod 4 ergab nur 1/2/3 — nie 0). Der Index verteilt
      // garantiert statt nur hoffentlich.
      var spread = DEMO_SPREADS[i % DEMO_SPREADS.length];
      // Pre-Order ist die Basis, auf die sich die Schwellenregel bezieht:
      // aus der echten Stufe zurueckrechnen, damit die Abstaende stimmen.
      var faktor = base.tier === '48h' ? (1 + spread.s48)
                 : base.tier === '72h' ? (1 + spread.s72)
                 : 1;
      var preorderPreis = demoRound(base.price / faktor);

      if (!vorhanden.preorder) {
        g.tiers.push(demoTierFrom(base, 'preorder', preorderPreis));
      }
      if (!vorhanden['72h']) {
        g.tiers.push(demoTierFrom(base, '72h', demoRound(preorderPreis * (1 + spread.s72))));
      }
      // Jede vierte Groesse bekommt KEINEN eigenen Bestand. Das ist realistisch
      // (48H ist eigene Ware, die liegt nie in allen Groessen) und noetig:
      // sonst waere jede Kachel blau und die 72H-Zeile der Legende kaeme in der
      // Vorschau ueberhaupt nicht vor.
      var hatEigenenBestand = i % 4 !== 3;
      if (!vorhanden['48h'] && hatEigenenBestand) {
        // Jede dritte Groesse liegt in beiden Filialen — damit auch der
        // Mehrfach-Standort-Fall sichtbar wird.
        var anzahl = (i % 3 === 0) ? 2 : 1;
        var orte = DEMO_LOCATIONS.slice(0, anzahl).map(function (n) {
          return { name: n, available: true };
        });
        g.tiers.push(demoTierFrom(base, '48h', demoRound(preorderPreis * (1 + spread.s48)), orte));
      }
      g.tiers.sort(function (a, b) { return TIER_RANK[a.tier] - TIER_RANK[b.tier]; });
    }
    return groups;
  }

  class SizePicker {
    constructor(sectionElement, productVariants, options) {
      this.section = sectionElement;
      this.pv = productVariants;
      this.options = options || {};

      var jsonEl = this.section.querySelector('[data-product-json]');
      if (!jsonEl || !this.pv) return;
      try { this.json = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var sectionId = this.json.section_id;
      // Der Drawer wurde von section-product.js bereits nach <body> verschoben.
      this.drawer = document.getElementById('SizePickerDrawer-' + sectionId);
      if (!this.drawer) return;

      try {
        this.settings = JSON.parse(this.drawer.getAttribute('data-size-picker-settings'));
        this.strings = JSON.parse(this.drawer.getAttribute('data-size-picker-strings'));
      } catch (e) { return; }

      this.model = normalizeVariants(this.json, this.settings);
      this.pv.sizeTiers = this.model;              // reichert variant:changed an
      var self = this;

      // Demo-Modus: Theme-Einstellung, per ?sp_demo=1 / ?sp_demo=0 uebersteuerbar.
      // Einmal eingeschaltet bleibt er fuer die Sitzung stehen — sonst geht er
      // beim ersten Klick auf ein anderes Produkt wieder verloren, weil der
      // Parameter in keinem Link des Shops mitlaeuft.
      this.demo = this.settings.demoTiers === true;
      try {
        var demoParam = new URLSearchParams(window.location.search).get('sp_demo');
        if (demoParam === '1') {
          this.demo = true;
          sessionStorage.setItem('aplug:sizePickerDemo', '1');
        } else if (demoParam === '0') {
          this.demo = false;
          sessionStorage.removeItem('aplug:sizePickerDemo');
        } else if (sessionStorage.getItem('aplug:sizePickerDemo') === '1') {
          this.demo = true;
        }
      } catch (e) {}

      this.groups = groupBySize(this.model.list, null);
      if (this.demo) {
        synthesizeDemoTiers(this.groups);
        // Erfundene Stufen muessen auffindbar sein, sonst laeuft _selectTier leer.
        this.groups.forEach(function (g) {
          g.tiers.forEach(function (t) { self.model.byVariantId[String(t.variantId)] = t; });
        });
      }
      // Im Demo-Modus die Schwelle abschalten: die Vorschau soll ja gerade
      // zeigen, wie die Wahl zwischen allen drei Stufen aussieht. Mit aktiver
      // Schwelle blieb bei den meisten Groessen nur eine Karte uebrig.
      var aufloesung = this.demo
        ? Object.assign({}, this.settings, { thresholdPercent: 0, showAll: true })
        : this.settings;
      this.groups = this.groups.map(function (g) { return resolveOfferedTiers(g, aufloesung); });
      if (!this.groups.length) return;

      this._locCache = {};                         // Filialen je Varianten-ID

      this.grid = this.drawer.querySelector('[data-size-picker-grid]');
      this.deliveryBox = this.drawer.querySelector('[data-size-picker-delivery]');
      this.deliveryList = this.drawer.querySelector('[data-size-picker-delivery-list]');
      this.titleEl = this.drawer.querySelector('[data-size-picker-title]');
      this.legendEl = this.drawer.querySelector('[data-size-picker-legend]');
      this.demoNoteEl = this.drawer.querySelector('[data-size-picker-demo-note]');
      this.expandEl = this.drawer.querySelector('[data-size-picker-expand]');
      this.addEl = this.drawer.querySelector('[data-size-picker-add]');
      this.unitToggle = this.drawer.querySelector('[data-size-picker-units]');
      this.summaryEl = this.section.querySelector('[data-size-picker-summary]');
      this.summaryTextEl = this.section.querySelector('[data-size-picker-summary-text]');
      this.summaryLabelEl = this.section.querySelector('[data-size-picker-summary-label]');
      this.summaryTierEl = this.section.querySelector('[data-size-picker-summary-tier]');
      this.summaryDotEl = this.section.querySelector('[data-size-picker-summary-dot]');

      var storedUnit = null;
      try { storedUnit = localStorage.getItem('aplug:sizeUnit'); } catch (e) {}
      this.state = {
        step: 'idle',
        unit: storedUnit || this.settings.defaultUnit || 'eu',
        sizeKey: null,
        variantId: null,
        expanded: false
      };

      // Einheiten-Umschalter nur, wenn es überhaupt zwei Schreibweisen gibt
      // (Apparel-Größen wie M/L/XL haben weder EU noch US).
      this.hasUnits = this.groups.some(function (g) { return g.sizeLabel.eu && g.sizeLabel.us; });
      if (this.unitToggle && !this.hasUnits) this.unitToggle.hidden = true;
      if (!this.hasUnits) this.state.unit = 'eu';
      this._renderUnitToggle();

      // Bleibt nach dem Ausblenden des Umschalters nichts uebrig (Apparel ohne
      // Groessentabelle), verschwindet die ganze Zeile statt leer zu stehen.
      var toolbar = this.drawer.querySelector('.SizePicker__Toolbar');
      if (toolbar) {
        var sichtbar = toolbar.querySelector('.SizePicker__SizeGuide') || this.hasUnits;
        toolbar.hidden = !sichtbar;
      }

      this.delegate = new themegoal.libs.Delegate(this.drawer);
      this._bind();
      this._renderLegend();
      if (this.demoNoteEl) this.demoNoteEl.hidden = !this.demo;

      // Es wird NIE etwas vorgewaehlt (Karim 2026-09-12, zweimal bestaetigt:
      // „es soll immer erst ‚Waehle deine Groesse‘ angezeigt werden“).
      //
      // Auch ?variant= waehlt nicht mehr vor. Das ist Absicht: unser eigener
      // Warenkorb-Klick schreibt ueber _commit() ein ?variant= in die URL, und
      // dieser Link taucht danach z.B. im Such-Overlay wieder auf. Wer ihn
      // anklickt, landete auf einer Seite mit vorgewaehlter Groesse, ohne je
      // etwas gewaehlt zu haben. Der Preis der Seite folgt weiterhin dem
      // Deep-Link — das macht ProductVariants —, die Groessenwahl nicht.
      this._building = true;
      this._renderGrid();
      // Ist ueberhaupt nichts kaufbar, sagt der Button das auch — sonst
      // stuende dort „Lieferoption waehlen“ ohne dass es eine gaebe.
      var anyAvailable = this.groups.some(function (g) { return g.available; });
      this._setAddEnabled(false, anyAvailable ? this.strings.chooseDelivery : this.strings.soldOut);
      this._building = false;
    }

    _bind() {
      var self = this;
      this.delegate.on('click', '[data-size-unit]', function (e, t) { self._setUnit(t.getAttribute('data-size-unit')); });
      this.delegate.on('click', '[data-size-key]', function (e, t) {
        if (t.hasAttribute('disabled')) return;
        self._selectSize(t.getAttribute('data-size-key'));
      });
      // NICHT Number(t.value): Demo-Stufen tragen absichtlich eine nicht
      // numerische ID ('demo-<id>-48h'), damit sie nie mit einer echten
      // Varianten-ID verwechselt werden koennen. Number() machte daraus NaN
      // und die Auswahl lief ins Leere. byVariantId ist ohnehin per String
      // geschluesselt.
      this.delegate.on('change', '[data-size-tier]', function (e, t) { self._selectTier(t.value); });
      this.delegate.on('click', '[data-size-picker-expand]', function () { self._toggleExpand(); });
      this.delegate.on('click', '[data-size-picker-add]', function () { self._addToCart(); });
      this.delegate.on('click', '[data-size-guide]', function (e, t) { self._openSizeGuide(t); });

      this._onAdded = function () {
        var inst = themegoal.components.Drawer.getInstance
          ? themegoal.components.Drawer.getInstance(self.drawer) : null;
        if (inst && inst.hide) inst.hide();
      };
      document.addEventListener('product:added', this._onAdded);
    }

    _currentGroup() {
      var key = this.state.sizeKey;
      if (!key) return null;
      for (var i = 0; i < this.groups.length; i++) if (this.groups[i].sizeKey === key) return this.groups[i];
      return null;
    }

    _label(group) {
      if (this.state.unit === 'us' && group.sizeLabel.us) return group.sizeLabel.us + ' US';
      if (this.state.unit === 'eu' && group.sizeLabel.eu) return group.sizeLabel.eu + ' EU';
      return group.sizeLabel.raw;
    }

    /** Aktiven Zustand der EU/US-Buttons anzeigen. Eigene Methode, weil der
     *  Konstruktor sie ebenfalls braucht: die Einheit kommt aus localStorage
     *  und muss beim Aufbau schon zum Grid passen. */
    _renderUnitToggle() {
      if (!this.unitToggle) return;
      var btns = this.unitToggle.querySelectorAll('[data-size-unit]');
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].getAttribute('data-size-unit') === this.state.unit;
        btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        btns[i].classList.toggle('SizePicker__Unit--active', on);
      }
    }

    _setUnit(unit) {
      if (!unit || unit === this.state.unit) return;
      this.state.unit = unit;
      try { localStorage.setItem('aplug:sizeUnit', unit); } catch (e) {}
      this._renderUnitToggle();
      this._renderGrid();
      this._renderTitle();
      this._renderSummary();
    }

    _visibleCount() {
      var perRow = 3;
      var rows = Number(this.settings.visibleRows) || 4;
      return perRow * rows;
    }

    _renderGrid() {
      if (!this.grid) return;
      var showSoldOut = this.settings.showSoldOut !== false;
      var shown = this.groups.filter(function (g) { return showSoldOut || g.available; });
      var limit = this.state.expanded ? shown.length : Math.min(shown.length, this._visibleCount());
      var html = '';

      for (var i = 0; i < limit; i++) {
        var g = shown[i];
        var selected = g.sizeKey === this.state.sizeKey;
        var priceHtml = '';
        if (g.minOfferedPrice != null) {
          var p = money(g.minOfferedPrice, this.settings.moneyFormat, g.minOfferedFormatted);
          priceHtml = '<span class="SizePicker__TilePrice">' +
            (g.hasMultipleOffered ? esc(this.strings.fromPrefix || '') + ' ' : '') + p + '</span>';
        } else {
          priceHtml = '<span class="SizePicker__TilePrice SizePicker__TilePrice--soldOut">' + esc(this.strings.soldOut) + '</span>';
        }
        // Markierung = schnellste angebotene Stufe. offeredTiers ist nach
        // TIER_RANK sortiert, [0] ist also die schnellste. Genau darauf
        // bezieht sich die Legende ueber dem Grid.
        var mark = g.offeredTiers.length ? g.offeredTiers[0].tier : null;
        var markHtml = (mark === '48h' || mark === '72h')
          ? '<span class="SizePicker__Dot" data-tier="' + mark + '" aria-hidden="true"></span>'
          : '';
        html += '<button type="button" role="radio" class="SizePicker__Tile' +
          (selected ? ' SizePicker__Tile--selected' : '') +
          (g.available ? '' : ' SizePicker__Tile--soldOut') + '"' +
          ' data-size-key="' + esc(g.sizeKey) + '"' +
          (mark ? ' data-tier="' + esc(mark) + '"' : '') +
          ' aria-checked="' + (selected ? 'true' : 'false') + '"' +
          (g.available ? '' : ' disabled') + '>' +
          markHtml +
          '<span class="SizePicker__TileSize">' + esc(this._label(g)) + '</span>' +
          priceHtml +
          '</button>';
      }
      this.grid.innerHTML = html;

      if (this.expandEl) {
        var hidden = shown.length <= this._visibleCount();
        this.expandEl.hidden = hidden;
        if (!hidden) {
          this.expandEl.textContent = this.state.expanded
            ? this.strings.showFewer
            : String(this.strings.showAll || '').replace('{{ count }}', shown.length).replace('{{count}}', shown.length);
        }
      }
    }

    /** Legende ueber dem Grid. Listet nur Stufen, die auf DIESER Seite als
     *  Kachel-Markierung auch wirklich vorkommen — sonst erklaert die Legende
     *  eine Farbe, die nirgends zu sehen ist. */
    _renderLegend() {
      if (!this.legendEl) return;
      if (this.settings.showBadge === false) { this.legendEl.hidden = true; return; }
      var vorhanden = {};
      this.groups.forEach(function (g) {
        if (g.offeredTiers.length) vorhanden[g.offeredTiers[0].tier] = true;
      });
      var tiers = this.strings.tiers || {};
      var html = '';
      ['48h', '72h'].forEach(function (t) {
        if (!vorhanden[t]) return;
        html += '<li class="SizePicker__LegendItem">' +
          '<span class="SizePicker__Dot" data-tier="' + t + '" aria-hidden="true"></span>' +
          esc((tiers[t] || {}).title || t) +
          '</li>';
      });
      this.legendEl.innerHTML = html;
      this.legendEl.hidden = !html;
    }

    _renderDelivery(group, scrollTo) {
      if (!this.deliveryBox || !this.deliveryList) return;
      if (!group || !group.offeredTiers.length) {
        this.deliveryBox.hidden = true;
        this.deliveryList.innerHTML = '';
        return;
      }
      var tiers = this.strings.tiers || {};
      var html = '';
      for (var i = 0; i < group.offeredTiers.length; i++) {
        var t = group.offeredTiers[i];
        var meta = tiers[t.tier] || {};
        var checked = String(t.variantId) === String(this.state.variantId);
        var compare = '';
        if (t.compareAtPrice && t.compareAtPrice > t.price) {
          compare = '<s class="SizePicker__CardCompare">' + money(t.compareAtPrice, this.settings.moneyFormat, t.formattedCompareAtPrice) + '</s>';
        }
        // Nur 48H liegt in einer eigenen Filiale — 72H kommt aus dem
        // Partnerlager, Pre-Order existiert physisch noch gar nicht. Den
        // Platz dafuer bekommt trotzdem jede Karte (feste Hoehe, siehe CSS),
        // gefuellt wird er nur bei 48H.
        var orteHtml = '<span class="SizePicker__CardLocations" data-locations-for="' + esc(t.variantId) + '"></span>';
        var demoHtml = t.demo
          ? '<span class="SizePicker__CardDemo">' + esc(this.strings.demoBadge || 'DEMO') + '</span>'
          : '';
        html += '<label class="SizePicker__Card' + (checked ? ' SizePicker__Card--selected' : '') +
          (t.demo ? ' SizePicker__Card--demo' : '') + '" data-tier="' + esc(t.tier) + '">' +
          '<input type="radio" class="SizePicker__CardInput" data-size-tier name="size-tier-' + esc(this.json.section_id) + '"' +
          ' value="' + esc(t.variantId) + '"' + (checked ? ' checked' : '') + '>' +
          '<span class="SizePicker__CardMain">' +
            '<span class="SizePicker__CardTitle">' + esc(meta.title || t.tier) + demoHtml + '</span>' +
            '<span class="SizePicker__CardInfo">' +
              '<span class="SizePicker__CardDesc">' + esc(meta.desc || '') + '</span>' +
              orteHtml +
            '</span>' +
          '</span>' +
          '<span class="SizePicker__CardPrice">' + compare + money(t.price, this.settings.moneyFormat, t.formattedPrice) + '</span>' +
          '</label>';
      }
      this.deliveryList.innerHTML = html;
      this.deliveryBox.hidden = false;

      var self = this;
      group.offeredTiers.forEach(function (t) {
        if (t.tier === '48h') self._fillLocations(t);
      });

      // Bei einem langen Groessenlauf (aplug fuehrt bis zu 16 Groessen) liegen
      // die Lieferoptionen sonst unter der Falz — der Kunde waehlt eine Groesse
      // und sieht Schritt 3 gar nicht. Nur nach einer echten Auswahl scrollen,
      // nicht beim Aufbau mit der Vorauswahl.
      if (scrollTo) {
        var scroller = this.drawer.querySelector('.Drawer__Body');
        if (scroller && scroller.scrollHeight > scroller.clientHeight) {
          // Eigene Rechnung statt scrollIntoView: das scrollt je nach Browser
          // das falsche Element (oder die Seite) und liess die Karten hier
          // unbewegt unter der Falz stehen.
          var ziel = this.deliveryBox.offsetTop - scroller.offsetTop - 12;
          // Direkt setzen, nicht scrollTo({behavior:'smooth'}): das wurde je
          // nach Rendering-Zustand verschluckt und liess die Karten stehen.
          // Die Animation macht CSS (scroll-behavior am Drawer-Body); der
          // Browser klemmt den Wert selbst auf das Maximum.
          if (ziel > scroller.scrollTop) {
            scroller.scrollTop = ziel;
          }
        }
      }
    }

    /**
     * Filialen einer 48H-Stufe. Shopify fuellt variant.store_availabilities
     * NUR fuer die gerade gewaehlte Variante (nachgemessen 2026-09-12), ein
     * Vorab-Dump aller Groessen ist daher unmoeglich. Deshalb bei Bedarf
     * nachladen — je Variante genau einmal, das Promise bleibt im Cache.
     */
    _fetchLocations(variantId) {
      var key = String(variantId);
      if (this._locCache[key]) return this._locCache[key];

      var root = (window.routes && window.routes.rootUrlWithoutSlash) || '';
      var url = root + '/variants/' + encodeURIComponent(variantId) + '?section_id=size-picker-availability';
      // Ohne diesen Parameter rendert der Request gegen das VEROEFFENTLICHTE
      // Theme — dort gibt es die Section nicht, und die Vorschau zeigte nie
      // eine Filiale.
      try {
        var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url += '&preview_theme_id=' + encodeURIComponent(preview);
      } catch (e) {}

      var p = fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-size-picker-availability]');
          if (!el) return [];
          try {
            var data = JSON.parse(el.textContent);
            return (data.locations || []).filter(function (l) { return l.available; });
          } catch (e) { return []; }
        })
        .catch(function () { return []; });

      this._locCache[key] = p;
      return p;
    }

    _paintLocations(variantId, orte) {
      if (!this.deliveryList) return;
      var slot = this.deliveryList.querySelector('[data-locations-for="' + String(variantId).replace(/"/g, '') + '"]');
      if (!slot) return;                       // Karte wurde inzwischen neu gerendert
      // Leer lassen, nicht verstecken: der Block haelt seine Hoehe (CSS).
      if (!orte || !orte.length) { slot.textContent = ''; return; }
      var label = orte.length > 1 ? (this.strings.inStores || '') : (this.strings.inStore || '');
      // Jede Filiale auf eine eigene Zeile. Nebeneinander brachen die beiden
      // unterschiedlich langen Namen unsauber um und standen dann auf
      // verschiedenen Hoehen.
      slot.innerHTML = '<span class="SizePicker__LocationsLabel">' + esc(label) + '</span> ' +
        orte.map(function (o) {
          return '<span class="SizePicker__Location">' + esc(o.name) + '</span>';
        }).join('');
    }

    _fillLocations(tier) {
      var self = this;
      if (tier.demo) {                         // erfundene Stufe: erfundene Filialen
        this._paintLocations(tier.variantId, tier.locations || []);
        return;
      }
      this._fetchLocations(tier.variantId).then(function (orte) {
        self._paintLocations(tier.variantId, orte);
      });
    }

    _renderTitle() {
      if (!this.titleEl) return;
      var g = this._currentGroup();
      if (!g) { this.titleEl.textContent = this.strings.drawerTitle; return; }
      var parts = [this.strings.sizeLabel + ' ' + this._label(g)];
      var sel = this.state.variantId ? this.model.byVariantId[String(this.state.variantId)] : null;
      if (sel) {
        var meta = (this.strings.tiers || {})[sel.tier];
        if (meta && meta.title) parts.push(meta.title);
      }
      this.titleEl.textContent = parts.join(' · ');
    }

    _renderSummary() {
      if (!this.summaryEl) return;
      var g = this._currentGroup();
      var sel = this.state.variantId ? this.model.byVariantId[String(this.state.variantId)] : null;
      if (!g || !sel) { this.summaryEl.hidden = true; return; }
      var meta = (this.strings.tiers || {})[sel.tier] || {};
      if (this.summaryLabelEl) this.summaryLabelEl.textContent = this.strings.selectedSize || '';
      if (this.summaryTextEl) this.summaryTextEl.textContent = this._label(g);
      if (this.summaryTierEl) this.summaryTierEl.textContent = meta.title || '';
      if (this.summaryDotEl) this.summaryDotEl.setAttribute('data-tier', sel.tier);
      this.summaryEl.hidden = false;
    }

    _setAddEnabled(enabled, labelWhenDisabled) {
      if (!this.addEl) return;
      var span = this.addEl.querySelector('span') || this.addEl;
      if (enabled) {
        this.addEl.removeAttribute('disabled');
        span.textContent = this.strings.addToCart;
      } else {
        this.addEl.setAttribute('disabled', 'disabled');
        span.textContent = labelWhenDisabled || this.strings.soldOut;
      }
    }

    _toggleExpand() {
      this.state.expanded = !this.state.expanded;
      this._renderGrid();
    }

    _selectSize(sizeKey) {
      var g = null;
      for (var i = 0; i < this.groups.length; i++) if (this.groups[i].sizeKey === sizeKey) g = this.groups[i];
      if (!g || !g.available) return;

      this.state.sizeKey = sizeKey;
      this.state.step = 'size';
      this.state.variantId = null;

      if (g.offeredTiers.length === 1) {
        // Nur eine Stufe: direkt übernehmen, der Kunde hat nichts zu wählen.
        this._selectTier(g.offeredTiers[0].variantId);
        return;
      }
      // Mehrere Lieferstufen: der grosse Preis zeigt, was auf der angetippten
      // Kachel stand — die guenstigste angebotene Stufe. Mit der Wahl der
      // Lieferoption wird daraus gleich der Preis genau dieser Stufe.
      this._previewPrice(this._cheapestOffered(g));
      this._renderGrid();
      this._renderDelivery(g, true);
      this._renderTitle();
      this._setAddEnabled(false, this.strings.chooseDelivery);
      this._emitWishlistVariant();
    }

    _selectTier(variantId) {
      var entry = this.model.byVariantId[String(variantId)];
      if (!entry) return;
      this.state.sizeKey = entry.sizeKey;
      this.state.variantId = entry.variantId;
      this.state.step = 'tier';

      // BEWUSST KEIN pv.selectVariant HIER (Karim 2026-09-12): die Wahl im
      // Drawer soll die Produktseite zunaechst unberuehrt lassen — ?variant=,
      // Galerie und Lagerinfo bleiben stehen. Uebernommen wird erst beim
      // Warenkorb-Klick, siehe _commit().
      //
      // Der PREIS ist seit 2026-09-16 ausgenommen (Kundenwunsch ueber Artur:
      // „main price should change always when u choose other size“). Er stand
      // sonst auf dem Ab-Preis, waehrend darunter „Gewaehlte Groesse 43 EU“
      // und in der Lieferkarte eine ganz andere Zahl standen.
      this._previewPrice(entry);

      this._renderGrid();
      this._renderDelivery(this._currentGroup(), !this._building);
      this._renderTitle();
      this._renderSummary();
      if (entry.demo) {
        // Die Stufe ist erfunden, es gibt sie in Shopify nicht.
        this._setAddEnabled(false, this.strings.demoHint);
      } else {
        this._setAddEnabled(entry.available, this.strings.soldOut);
      }
      this._emitWishlistVariant();
    }

    // Drawer trzyma wariant do kliknięcia „dodaj do koszyka”. Serce ma iść za
    // wyborem od razu, bez variant:changed.
    _emitWishlistVariant() {
      if (this._building || !this.json) return;
      var id = Number(this.state.variantId);
      document.dispatchEvent(new CustomEvent('sizepicker:variant', {
        detail: {
          sectionId: String(this.json.section_id),
          variantId: id || 0
        }
      }));
    }

    /** Die guenstigste angebotene Stufe einer Groesse — die, deren Preis auf
     *  der Kachel steht. */
    _cheapestOffered(group) {
      if (!group || !group.offeredTiers || !group.offeredTiers.length) return null;
      return group.offeredTiers.reduce(function (cheapest, tier) {
        return tier.price < cheapest.price ? tier : cheapest;
      }, group.offeredTiers[0]);
    }

    /** Schreibt den grossen Preis der Produktseite auf die angetippte Stufe
     *  um. Nur den Preis: die Variante selbst wird weiter erst beim
     *  Warenkorb-Klick uebernommen. `null` stellt den Ab-Preis wieder her. */
    _previewPrice(tier) {
      if (!this.pv || typeof this.pv.previewPrice !== 'function') return;
      if (!tier) { this.pv.previewPrice(null); return; }
      this.pv.previewPrice({
        price: tier.price,
        compareAtPrice: tier.compareAtPrice,
        formattedPrice: tier.formattedPrice,
        formattedCompareAtPrice: tier.formattedCompareAtPrice
      });
    }

    /** Uebernimmt die im Drawer getroffene Wahl auf die Produktseite. Erst
     *  hier haengen Preis, ?variant=, verstecktes Select, variant:changed,
     *  Galerie und Lagerinfo dran — alles ueber ProductVariants. */
    _commit() {
      var entry = this.state.variantId ? this.model.byVariantId[String(this.state.variantId)] : null;
      if (!entry || entry.demo) return false;
      if (this.pv && typeof this.pv.selectVariant === 'function') {
        this.pv.selectVariant(entry.variantId);
      }
      return true;
    }

    _addToCart() {
      if (this.state.step !== 'tier' || !this.state.variantId) return;
      // Uebernahme erst jetzt — vorher weiss das Formular nichts von der Wahl.
      if (!this._commit()) return;
      if (this.pv && typeof this.pv.addToCart === 'function') this.pv.addToCart();
    }

    _openSizeGuide(trigger) {
      var target = trigger.getAttribute('data-tg-target');
      var modal = target ? document.querySelector(target) : null;
      if (!modal) return;
      var drawerInst = themegoal.components.Drawer.getInstance
        ? themegoal.components.Drawer.getInstance(this.drawer) : null;
      if (drawerInst && drawerInst.hide) drawerInst.hide();
      var Modal = themegoal.components.Modal;
      var inst = Modal.getOrCreateInstance ? Modal.getOrCreateInstance(modal) : new Modal(modal);
      if (inst && inst.show) inst.show();
    }

    destroy() {
      if (this.delegate && this.delegate.destroy) this.delegate.destroy();
      if (this._onAdded) document.removeEventListener('product:added', this._onAdded);
    }
  }

  return {
    TIER_RANK: TIER_RANK,
    parseSizeValue: parseSizeValue,
    sizeToNumber: sizeToNumber,
    normalizeVariants: normalizeVariants,
    groupBySize: groupBySize,
    resolveOfferedTiers: resolveOfferedTiers,
    SizePicker: SizePicker
  };
}));
